import React from 'react';
import { FaClipboardList, FaDesktop, FaRocket } from 'react-icons/fa';
import './HowItWorks.css';

const HowItWorks = () => {
  const steps = [
    {
      id: 1,
      icon: <FaClipboardList />,
      title: "Submit Exam Details",
      description: "Tell us about your exam or assessment — platform, proctor, date, and your current setup.",
      details: [
        "Exam type, date & time",
        "Proctor & platform (Proctorio, HireVue, etc.)",
        "Your OS & hardware setup"
      ]
    },
    {
      id: 2,
      icon: <FaDesktop />,
      title: "Fast Remote Setup & Demo",
      description: "We set everything up remotely in no time and walk you through a live demo so you feel fully prepared.",
      details: [
        "Quick remote installation & activation",
        "Live demo of the solution in action",
        "We explain how to stay undetected"
      ],
      badge: "Same-day setup"
    },
    {
      id: 3,
      icon: <FaRocket />,
      title: "Pass & Pay",
      description: "Take your exam with our solution handling everything — and pay only after you've successfully passed.",
      details: [
        "💰 $0 upfront — pay after you pass",
        "Relax while the solution does the work",
        "Free Module 3 demo included"
      ],
      badge: "Pay after you pass",
      highlight: true
    }
  ];

  return (
    <section className="how-it-works">
      <div className="how-container">
        
        {/* Header */}
        <div className="how-header">
          <h2 className="how-title">How It Works</h2>
          <p className="how-subtitle">Simple 3-step process — from exam details to passing and paying</p>
        </div>

        {/* Timeline */}
        <div className="timeline">
          <div className="timeline-line"></div>
          
          {steps.map((step, index) => (
            <div 
              key={step.id} 
              className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'} ${step.highlight ? 'highlight' : ''}`}
            >
              {/* Number Circle */}
              <div className="step-number">
                <span>{step.id}</span>
              </div>

              {/* Content Card */}
              <div className="step-card">
                <div className="step-icon">
                  {step.icon}
                </div>
                
                <h3 className="step-title">{step.title}</h3>
                
                {step.badge && (
                  <div className="step-badge">
                    {step.badgeIcon && <span className="badge-icon">{step.badgeIcon}</span>}
                    <span>{step.badge}</span>
                  </div>
                )}
                
                <p className="step-description">{step.description}</p>
                
                {step.details && step.details.length > 0 && (
                  <ul className="step-details">
                    {step.details.map((detail, idx) => (
                      <li key={idx}>{detail}</li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default HowItWorks;
